(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hydra-funnel-bridge"] && !Shopify.designMode) return;
  try {
    (function () {
  var root = document.querySelector('[data-hydra-funnel-bridge]');
  if (!root || root.dataset.hydraReady === 'true') return;
  root.dataset.hydraReady = 'true';

  var storageKey = 'hydra_shopify_first_touch_v1';
  var sessionKey = 'hydra_shopify_session_v1';
  var params = new URLSearchParams(window.location.search);

  function clean(value, limit) {
    return String(value || '').replace(/[<>]/g, '').trim().slice(0, limit || 180);
  }

  function readStored() {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey) || 'null');
    } catch (error) {
      return null;
    }
  }

  function sourceFromReferrer() {
    try {
      return document.referrer ? new URL(document.referrer).hostname : 'direct';
    } catch (error) {
      return 'direct';
    }
  }

  function createSessionId() {
    try {
      var existing = window.sessionStorage.getItem(sessionKey);
      if (existing) return existing;
      var next = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : Date.now().toString(36) + Math.random().toString(36).slice(2);
      window.sessionStorage.setItem(sessionKey, next);
      return next;
    } catch (error) {
      return Date.now().toString(36);
    }
  }

  var firstTouch = readStored();
  if (!firstTouch) {
    firstTouch = {
      source: clean(params.get('utm_source') || sourceFromReferrer(), 80).toLowerCase(),
      medium: clean(params.get('utm_medium'), 80).toLowerCase(),
      campaign: clean(params.get('utm_campaign'), 120).toLowerCase(),
      content: clean(params.get('utm_content'), 120).toLowerCase(),
      term: clean(params.get('utm_term'), 120).toLowerCase(),
      funnel_stage: clean(params.get('funnel_stage'), 40).toLowerCase(),
      funnel_key: clean(params.get('funnel_key'), 80).toLowerCase(),
      landing_page: clean(window.location.pathname, 180),
      captured_at: new Date().toISOString(),
    };
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(firstTouch));
    } catch (error) {
    }
  }

  var attributes = {
    '_hydra_source': firstTouch.source || 'direct',
    '_hydra_medium': firstTouch.medium || '',
    '_hydra_campaign': firstTouch.campaign || '',
    '_hydra_content': firstTouch.content || '',
    '_hydra_term': firstTouch.term || '',
    '_hydra_funnel_stage': firstTouch.funnel_stage || '',
    '_hydra_funnel_key': firstTouch.funnel_key || '',
    '_hydra_landing_page': firstTouch.landing_page || '',
    '_hydra_first_touch_at': firstTouch.captured_at || '',
    '_hydra_session_id': createSessionId(),
  };

  function publish(name, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, hydra: detail });
    window.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  function persistCartAttribution() {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      credentials: 'same-origin',
      keepalive: true,
    }).catch(function () {});
  }

  persistCartAttribution();

  if (root.dataset.pageType === 'product' && root.dataset.productId) {
    publish('hydra_product_view', {
      product_id: root.dataset.productId,
      product_handle: root.dataset.productHandle,
      source: attributes._hydra_source,
      campaign: attributes._hydra_campaign,
      funnel_key: attributes._hydra_funnel_key,
    });
  }

  document.addEventListener('click', function (event) {
    var addButton = event.target.closest('[name="add"], [data-add-to-cart], button[type="submit"]');
    if (addButton && addButton.closest('form[action*="/cart/add"]')) {
      persistCartAttribution();
      publish('hydra_add_to_cart_intent', {
        product_id: root.dataset.productId,
        product_handle: root.dataset.productHandle,
        source: attributes._hydra_source,
        campaign: attributes._hydra_campaign,
        funnel_key: attributes._hydra_funnel_key,
      });
    }

    var checkoutButton = event.target.closest('[name="checkout"], [href*="/checkout"], [data-checkout]');
    if (checkoutButton) {
      persistCartAttribution();
      publish('hydra_checkout_intent', {
        source: attributes._hydra_source,
        campaign: attributes._hydra_campaign,
        funnel_stage: attributes._hydra_funnel_stage,
        funnel_key: attributes._hydra_funnel_key,
      });
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
